const STORAGE_KEY = 'obank_registration';

export async function registerWithPhone({ initData, phoneNumber, telegramUserId }) {
  const registration = {
    initData,
    phoneNumber,
    telegramUserId,
    registeredAt: Date.now(),
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(registration));
  return registration;
}

export function getRegistration() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function savePasscode(passcode) {
  const registration = getRegistration() ?? {};
  const updated = {
    ...registration,
    passcode,
    passcodeSetAt: Date.now(),
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return updated;
}

export function clearPasscode() {
  const registration = getRegistration();

  if (!registration) {
    return null;
  }

  const updated = { ...registration };
  delete updated.passcode;
  delete updated.passcodeSetAt;

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return updated;
}
